module.exports = __webpack_public_path__ + "img/Imagem_4.c0dd3677.png";